import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { shiftNames } from '../../../_helpers/constants';
import Img from '../../../elements/Img';
import { profileThumb, shiffyAvatar, vtoAvatar } from '../../../icons';

const ProfileImg = styled(Img)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: ${(props) => props.borderRadius};
`;

class ProfileThumb extends React.PureComponent {
  thumbImgRef = React.createRef();

  _handleOnError = () => {
    this.thumbImgRef.current.src = profileThumb;
  }

  _determineSrc = () => {
    const { icon, shiftName, thumbUrl } = this.props;

    if (shiftName) {
      switch (shiftName) {
        case shiftNames.SHIFT:
        case shiftNames.SHIFT_INVENTORY:
          return thumbUrl;
        case shiftNames.SHIFT_VTO:
          return vtoAvatar;
        case shiftNames.OPEN_SHIFT:
          return shiffyAvatar;
        default:
          break;
      }
    } else if (icon) {
      switch (icon) {
        case 'shiffy':
          return shiffyAvatar;
        case 'vto':
          return vtoAvatar;
        default:
          return profileThumb;
      }
    }

    return thumbUrl || profileThumb;
  }

  render() {
    const {
      width,
      height,
      borderRadius,
      className,
    } = this.props;

    return (
      <ProfileImg
        src={this._determineSrc()}
        alt="User Thumb"
        onError={this._handleOnError}
        ref={this.thumbImgRef}
        width={width}
        height={height}
        borderRadius={borderRadius}
        className={className}
      />
    );
  }
}

ProfileThumb.propTypes = {
  thumbUrl: PropTypes.string,
  icon: PropTypes.oneOf([
    'shiffy',
    'vto',
  ]),
  shiftName: PropTypes.oneOf(Object.values(shiftNames)),
  width: PropTypes.string,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
  className: PropTypes.string,
};

ProfileThumb.defaultProps = {
  thumbUrl: null,
  icon: null,
  shiftName: null,
  width: '100%',
  height: 'auto',
  borderRadius: '100%',
  className: '',
};

export default ProfileThumb;
